import React from 'react';

import { ISubstitution, NotificationsEditableContent } from '../NotificationsEditableContent';

interface EditableContentEmailProps {
  value?: string;
  substitutions: ISubstitution[];
  inputStyle: React.CSSProperties;
  placeholder?: string;
  visibleSubstitutions: boolean;
  setVisibleSubstitutions: (value: boolean) => any;
  onValueChange: (value: string) => any;
}

const EditableContentEmail = ({
  value,
  substitutions,
  inputStyle,
  placeholder,
  visibleSubstitutions,
  setVisibleSubstitutions,
  onValueChange,
}: EditableContentEmailProps) => {
  return (
    <NotificationsEditableContent
      id="email-notifications-editable-content"
      value={value}
      substitutions={substitutions}
      inputStyle={inputStyle}
      placeholder={placeholder}
      visibleSubstitutions={visibleSubstitutions}
      setVisibleSubstitutions={setVisibleSubstitutions}
      onValueChange={onValueChange}
    />
  );
};

export default EditableContentEmail;
